import { GETTER_AUTH_USER, GETTER_APP_INIT_STATE } from './types';

export default {
  [GETTER_AUTH_USER]: ({ authUser }) => authUser,
  [GETTER_APP_INIT_STATE]: ({ appInitState }) => appInitState,
};
